angular.module('Itao.IndicatorMap', ['ngAnimate', 'ngSanitize', 'ui.tree', 'ui.tree-filter', 'dndLists', 'ui.bootstrap', 'textAngular', 'rzModule'])
  .config(function($provide) {
    'use strict';
    $provide.decorator('taOptions', ['taRegisterTool', 'taToolFunctions', '$delegate', 'ModalService', 'mapConfig', function(taRegisterTool, taToolFunctions, taOptions, ModalService, mapConfig){

      taRegisterTool('insertLinkModal', {
        tooltiptext: 'add link',
        iconclass: 'fa fa-link',
        action: function(promise, restoreSelection){
          var that = this;
          ModalService.createCustomModal({}, {
            templateUrl: mapConfig.templateBasePath + 'modals/addLink.html',
            controller: 'TextfieldModalController'
          }).result.then(function(urlAdress){
            if (urlAdress) {
              restoreSelection(); // selection will be lost in the modal interaction - you need to have rangy core and rangy saveselection enabled, or the minified rangy bundle from the repo
              that.$editor().wrapSelection('createLink', urlAdress, true);
              promise.resolve(); // this tells the editor you're done and bindings should be updated now
            }
          });
          return false;
        },
        activeState: function(commonElement){
          if(commonElement) return commonElement[0].tagName === 'A';
          return false;
        }/*,
         onElementSelect: {
         element: 'a',
         action: taToolFunctions.aOnSelectAction
         }*/
      });
      taOptions.classes = {
        focussed: 'focussed',
        toolbar: 'btn-toolbar',
        toolbarGroup: 'btn-group btn-group-sm',
        toolbarButton: 'btn btn-default',
        toolbarButtonActive: 'active',
        disabled: 'disabled',
        textEditor: '',
        htmlEditor: ''
      };
      return taOptions;
    }]);
  });
